import { render, staticRenderFns } from "./field.vue?vue&type=template&id=51f867dc&scoped=true&"
import script from "./field.js?vue&type=script&lang=js&"
export * from "./field.js?vue&type=script&lang=js&"
import style0 from "./field.scss?vue&type=style&index=0&id=51f867dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f867dc",
  null
  
)

export default component.exports